import { render, staticRenderFns } from "./InstHeader.vue?vue&type=template&id=50d0cab3&scoped=true&"
import script from "./InstHeader.vue?vue&type=script&lang=js&"
export * from "./InstHeader.vue?vue&type=script&lang=js&"
import style0 from "./InstHeader.vue?vue&type=style&index=0&id=50d0cab3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d0cab3",
  null
  
)

export default component.exports